// extracted by mini-css-extract-plugin
export default {"root":"DetailHrefButtonRow_root__cmUIH","item":"DetailHrefButtonRow_item__OtqPd"};